import { render, staticRenderFns } from "./editablePolicyList.vue?vue&type=template&id=1f388420"
import script from "./editablePolicyList.vue?vue&type=script&lang=js"
export * from "./editablePolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports